"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.initializeCommand = void 0;var _command = require("./command");
var _authenticationTokens = require("../models/authenticationTokens");


/**
 * Starts the initialization process
 * @param id - command ID
 * @param config
 */
const initializeCommand = (id, config) => {
  config.authenticationFrame.contentWindow.postMessage(
    new _command.Command(config.clientType, _command.Command.Commands.initialize, {
      id
    }),
    '*'
  );

  //will remove expired tokens before any authentication begins for sanity-sake
  _authenticationTokens.AuthenticationTokens.get();
};exports.initializeCommand = initializeCommand;